import React, { useState } from 'react';
import { db, auth } from "../firebase.js";
import firebase from "firebase/compat/app";
import { Input } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

function SendMessege() {
    const [messege, setMessege] = useState("");
    function SendMessege(e) {
        e.preventDefault();

        const { uid, photoURL } = auth.currentUser;

        db.collection("messeges").add({
            text: messege,
            photoURL,
            uid,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        setMessege("");
    }
    return (
        <div>
            <form onSubmit={SendMessege}>
                <div className='sendMsg'>
                    <Input
                    style={{
                        width: "78%",
                        fontSize: "15px",
                        fontWeight: "550",
                        marginLeft: "5px",
                        marginBottom: "-3px",
                    }}
                        placeholder='メッセージを入力してください'
                        type='text'
                        onChange={(e) => setMessege(e.target.value)}
                        value={messege}
                    />
                    <SendIcon style={{ color: "#7AC2FF", marginLeft: "20px" }} />
                </div>
            </form>
        </div>
    )
}

export default SendMessege